import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { selectPlayerLevel } from "../../../selectors/selectPlayerLevelInfo";
import { TypeActionPlayerInfo } from "../../info/player/actionPlayerInfo";
import { actionAppsflyerUpdate } from "../actionAppsflyer";
import { IdAppsflyerEvents } from "../IdAppsflyerEvents";
export var epicAppsflyerLevelAchieved = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPlayerInfo.AddLevel), switchMap(function () {
        var level = selectPlayerLevel(state$.value);
        var eventValue = {
            LEVEL: level,
        };
        return from([
            actionAppsflyerUpdate(IdAppsflyerEvents.LEVEL_ACHIEVED, eventValue),
            actionAppsflyerUpdate(IdAppsflyerEvents.CURRENT_LEVEL, eventValue),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/appsflyer/epics/epicAppsflyerLevelAchieved.ts
// module id = 1773
// module chunks = 3